module.exports = __webpack_public_path__ + "693c25af144e65dfa6e97ea2983289c0.png";